var _rect, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInProgress = function SvgInProgress(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31 -16H263V263C263 267.418 259.418 271 255 271H-23C-27.4183 271 -31 267.418 -31 263V-16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13,
    y: -8,
    width: 140,
    height: 32,
    rx: 16,
    fill: "#D6DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67651 0.5V1.91612C10.7541 2.29469 12.9344 5.09189 12.5558 8.1695C12.2333 10.7213 10.2283 12.7474 7.67651 13.0488V14.4509C11.5323 14.0653 14.3365 10.6442 13.9509 6.78843C13.6355 3.45844 10.9925 0.829494 7.67651 0.5ZM6.27441 0.521032C4.90736 0.654231 3.6034 1.18002 2.53781 2.06335L3.54031 3.1009C4.32549 2.46995 5.27191 2.06334 6.27441 1.92313V0.521032ZM1.54932 3.05183C0.672768 4.11556 0.133341 5.41653 0 6.78843H1.4021C1.5353 5.79294 1.92789 4.84652 2.55183 4.05433L1.54932 3.05183ZM0.00701051 8.19054C0.147221 9.5646 0.687031 10.8615 1.55633 11.9271L2.55183 10.9246C1.93275 10.1322 1.53807 9.18785 1.40911 8.19054H0.00701051ZM3.54031 11.9552L2.53781 12.9156C3.59975 13.8008 4.89984 14.3521 6.27441 14.5V13.0979C5.2771 12.9689 4.33278 12.5743 3.54031 11.9552ZM7.32599 3.98423V7.66475L10.4807 9.53656L9.95493 10.3988L6.27441 8.19054V3.98423H7.32599Z",
    fill: "#5A67DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 287,
    fill: "white",
    transform: "translate(-31 -16)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInProgress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in_progress.5c11854c.svg";
export { ForwardRef as ReactComponent };